import { inject, Injectable } from '@angular/core';
import { ContestApi } from './api/contest-api.types';
import { ContestStore } from './contest-store';
import { firstValueFrom } from 'rxjs';
import { Templates, TemplatesKeys } from 'app/features/contest/models/templates';
import { TemplateType } from 'app/features/contest/models/contest-template.models';
import { IUserInfo } from 'app/features/contest/models/contest-user-info.models';

@Injectable()
export class ContestInformationService {
  private readonly api: ContestApi = inject(ContestApi);
  private readonly contestStore: ContestStore = inject(ContestStore);

  async loadContestInformation(): Promise<void> {
    const contestInfo: IUserInfo = await firstValueFrom(
      this.api.getUserInfo(this.contestStore.username(), this.contestStore.hashid())
    );

    this.contestStore.trackInfo.set(contestInfo.track_infos);
    this.contestStore.userInfo.set(contestInfo.user_infos);

    const templateKey: TemplatesKeys | undefined = contestInfo.template?.template;
    const template: TemplateType | undefined = templateKey ? Templates[templateKey] : undefined;

    if (template) this.contestStore.template.set(template);
  }
}
